import { getFatalError, getMarketingState, getAccountState } from '@common/state/selectors'
import { AppState } from 'app-store'
import { getCheckoutState, getLabelContent, getPlanData } from '@lmipro/state/selectors'
import { getUserSubscribedAddons } from '@lmipro/utils'
import { getCurrentPlan } from '@lmipro/utils/get-current-plan'
import { LmiProCheckoutFormSubmissionState } from './state'

export const mapLmiProCheckoutFormSubmissionState = (state: AppState): LmiProCheckoutFormSubmissionState => {
    const { completePurchase, pricingNote, optOut, optOutCheckboxLabel } = getLabelContent(state)
    const { isFatalError, fatalErrorBlocker } = getFatalError(state)
    const { totalLoading, calculatedTotal, selectedPlanSku } = getCheckoutState(state)
    const { displayOptOut } = getMarketingState(state)
    const { accountSubscriptions } = getAccountState(state)
    const planData = getPlanData(state)
    const currSelectedPlan = getCurrentPlan(selectedPlanSku, planData)
    const { disablePlanSelection } = getUserSubscribedAddons(accountSubscriptions, currSelectedPlan)

    return {
        content: { completePurchase, pricingNote, optOut, optOutCheckboxLabel },
        isFatalError,
        fatalErrorBlocker,
        totalLoading,
        displayOptOut,
        calculatedTotal,
        disablePlanSelection,
    }
}

export const mapLmiProCheckoutFormSubmissionActions = {}

export type LmiProCheckoutFormSubmissionActionsType = typeof mapLmiProCheckoutFormSubmissionActions
